import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { MasterBlockId } from 'src/shared/types/base-entity-interface'
import { generateBaseEntity } from '../utils/generate-base-entity'

export function createOrderSummary(
  parentId: string,
  masterBlockId?: MasterBlockId,
): EntityInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.OrderSummary, parentId, masterBlockId),
  }
}
